import { connect } from 'react-redux';
import ArtistSingleComponent from '../components/ArtistSingleComponent';
import * as ArtistSingleActions from '../actions/ArtistSingleActions';

const mapStateToProps = (state) => ({
    dataArtistSingle: state.artists.ArtistSingle.dataArtistSingle,
    // isFetching: state.artists.ArtistSingle.isFetching,
    breakpoint: state.breakpointReducer,
    notFound: state.artists.ArtistSingle.notFound,
    // news: state.artists.ArtistSingle.news,
    // isRelatedNews: state.artists.ArtistSingle.isRelatedNews,
});
const mapDispatchToProps = (dispatch) => ({
    getSingleArtistIfNeeded: (slug) => {
        dispatch(ArtistSingleActions.getSingleArtistIfNeeded(slug));
    },
    setNotFound: (notFound) => {
        dispatch(ArtistSingleActions.setNotFound(notFound));
    },
});
const ArtistSingleContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ArtistSingleComponent);

export default ArtistSingleContainer;
